// extracted by extract-css-chunks-webpack-plugin
module.exports = {"onboardingStep":"_10UrwR","link":"_1Jj5m2","secondaryAction":"_1MnJHN","contentWrapper":"_1e7AFB","closeLink":"_3PiUaN","title":"_1o29G4","nextLink":"_2WMcEk"};